const moment = require('moment');
const d3 = require('d3');
const { getCurrencySymbol, getFormattedAmount } = require('utilities/currencyHelper');
const { DATE_PICKER_CUSTOM_LOCALE } = require('constants/commonsComponents');
const { formatText } = require('core/i18n').i18n;
const es_ES = {
    'decimal': '.',
    'thousands': ',',
    'grouping': [3],
    'currency': ['$', '€'],
    'dateTime': '%a %b %e %X %Y',
    'date': '%m/%d/%Y',
    'time': '%H:%M:%S',
    'periods': ['AM', 'PM'],
    'days': ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    'shortDays': ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    'months': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    'shortMonths': ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
};
const en_US = {
    'decimal': '.',
    'thousands': ',',
    'grouping': [3],
    'currency': ['\$', '€'],
    'dateTime': '%a %b %e %X %Y',
    'date': '%m/%d/%Y',
    'time': '%H:%M:%S',
    'periods': ['AM', 'PM'],
    'days': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    'shortDays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    'months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    'shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};

const decideAxisDateLabel = (maxDate, minDate) => {
    const diffDays = maxDate.diff(minDate, 'days');
    let loc;
    const locale = formatText(DATE_PICKER_CUSTOM_LOCALE);

    if (locale === 'es') {
        loc = d3.locale(es_ES);
    } else if (locale === 'en') {
        loc = d3.locale(en_US);
    } else {
        loc = d3.locale(en_US);
    }

    if (diffDays < 32) {
        return loc.timeFormat('%d %b');
    } else if (diffDays > 31 && diffDays < 360) {
        return loc.timeFormat('%b %Y');
    } else {
        return loc.timeFormat('%b %Y');
    }
};

const yAxisFormatLabel = (d, currencyId) => {
    const moneyObj = { amount: d, currency: currencyId };
    const curr = getCurrencySymbol(moneyObj);
    const amount = getFormattedAmount(moneyObj);

    return amount + ' ' + curr;
};

const createTooltip = (d, currencyId) => {
    const locMoment = moment.utc(d.date).locale(DATE_PICKER_CUSTOM_LOCALE);
    const formattedDate = locMoment.format('DD MMM YYYY');
    const moneyObj = { amount: d.value, currency: currencyId };
    const fa = getFormattedAmount(moneyObj);
    const fs = getCurrencySymbol(moneyObj);

    return `${formattedDate} <span>${fa} ${fs}</span>`;
};

const dateTicks = (min, max) => {
    const monthsDiff = max.month() - min.month();
    /**
     * TODO fix here if we want to set manual the ticks with .tickValues()
     * 2 is for the extremes
     */

    return monthsDiff + 2;
};

module.exports = {
    decideAxisDateLabel,
    yAxisFormatLabel,
    createTooltip,
    dateTicks
};
